import React, { FC, createContext, useContext, useState } from "react";

type Row = {
  _id: string;
  [key: string]: unknown;
};

export const DataGridSelectionContext = createContext({
  selectedRows: [] as Row[],
  setSelectedRows: (_rows: Row[]) => {},
});

export const DataGridSelectionProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedRows, setSelectedRows] = useState<Row[]>([]);

  return (
    <DataGridSelectionContext.Provider
      value={{ selectedRows, setSelectedRows }}
    >
      {children}
    </DataGridSelectionContext.Provider>
  );
};

export const useDataGridSelection = () => {
  const ctx = useContext(DataGridSelectionContext) || {
    selectedRows: [] as Row[],
    setSelectedRows: () => {},
  };
  return {
    selectedRows: ctx.selectedRows,
    setSelectedRows: ctx.setSelectedRows,
  };
};

export default DataGridSelectionProvider;
